module.exports = __webpack_public_path__ + "static/media/5.013fab86.svg";